var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "user-sign" },
    [
      _c(
        "el-card",
        {
          staticStyle: {
            width: "100%",
            height: "100%",
            "box-sizing": "border-box",
          },
        },
        [
          _c(
            "div",
            {
              staticStyle: { "font-weight": "bold", "font-size": "18px" },
              attrs: { slot: "header" },
              slot: "header",
            },
            [_vm._v(" 用户信息 ")]
          ),
          !_vm.isOver
            ? _c(
                "el-form",
                {
                  ref: "form",
                  attrs: {
                    model: _vm.UserInfo,
                    "label-width": "100px",
                    "label-position": "left",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "账号" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.UserInfo.AccountName,
                          callback: function ($$v) {
                            _vm.$set(_vm.UserInfo, "AccountName", $$v)
                          },
                          expression: "UserInfo.AccountName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "名称" } },
                    [
                      _c("el-input", {
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.UserInfo.PMC_Name,
                          callback: function ($$v) {
                            _vm.$set(_vm.UserInfo, "PMC_Name", $$v)
                          },
                          expression: "UserInfo.PMC_Name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "联系人" } },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.UserInfo.Person,
                          callback: function ($$v) {
                            _vm.$set(_vm.UserInfo, "Person", $$v)
                          },
                          expression: "UserInfo.Person",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", { attrs: { label: "签名" } }, [
                    !_vm.UserInfo.Sign
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              height: "100px",
                              border: "1px solid #ccc",
                              "line-height": "100px",
                              "text-align": "center",
                              width: "100%",
                              "box-sizing": "border-box",
                              "background-color": "#fff",
                            },
                            on: {
                              click: function ($event) {
                                _vm.signVisible = true
                              },
                            },
                          },
                          [_vm._v(" 点击预制签名 ")]
                        )
                      : _vm._e(),
                    _vm.UserInfo.Sign
                      ? _c(
                          "div",
                          {
                            staticStyle: {
                              display: "flex",
                              "align-items": "center",
                              "justify-content": "center",
                              height: "100px",
                              "text-align": "center",
                              "box-sizing": "border-box",
                              overflow: "hidden",
                              width: "100%",
                              border: "1px solid #ccc",
                            },
                            on: {
                              click: function ($event) {
                                _vm.signVisible = true
                              },
                            },
                          },
                          [
                            _c("img", {
                              staticStyle: {
                                width: "100%",
                                background: "#fff",
                                "box-sizing": "border-box",
                                height: "100px",
                              },
                              attrs: { src: _vm.UserInfo.Sign, alt: "" },
                            }),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            size: "mini",
                            type: "primary",
                            loading: _vm.loading,
                          },
                          on: { click: _vm.onSubmitUserInfo },
                        },
                        [_vm._v("保存 ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isOver
            ? _c(
                "el-result",
                {
                  attrs: {
                    icon: "success",
                    title: "修改成功",
                    subTitle: "PC浏览器请刷新浏览器页面",
                  },
                },
                [_c("template", { slot: "extra" })],
                2
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.signVisible
        ? _c(
            "div",
            {
              staticStyle: {
                width: "100vw",
                height: "100vh",
                position: "fixed",
                top: "0",
                left: "0",
                "z-index": "99",
              },
            },
            [
              _c("sign", {
                attrs: { useSing: false },
                on: {
                  close: function ($event) {
                    _vm.signVisible = false
                  },
                  success: _vm.signSub,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }